/* For assertions in lists containing algorithms */
const css = String.raw;

// Prettier ignore only to keep code indented from level 0.
// prettier-ignore
export default css`
.assert {
  background: #eee;
  border-left: 0.5em solid #aaa;
  padding: 0.3em;
}
`;
